import React from "react";
import Navbar from "react-bootstrap/Navbar";
import { useTranslation } from "react-i18next";

import styles from "../assets/styles/footer.module.scss";

export function Footer() {
  const { t, i18n } = useTranslation("common");

  return (
    <Navbar className={`${styles.footerContainer} justify-content-center text-center d-block`}>
      {t("rights")}
      <a href="#" data-cc="show-preferencesModal">{t("cookie-manager")}</a>
      <a href="https://www.livroreclamacoes.pt/inicio" target="_blank">{t("complaints-book")}</a>
    </Navbar>
  );
}
